import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ComboBoxOption } from 'src/app/models/combo-box-option';
import {
  PrintBatch,
  ProductDistribution,
} from 'src/app/models/register/product/product-distribution';
import { ProductDistributionDetail } from 'src/app/models/register/product/product-distribution-detail';
import { Reprint } from 'src/app/models/reprint';
import { ProductService } from 'src/app/services/product/product.service';
import { ReprintService } from 'src/app/services/reprint/reprint.service';

@Component({
  selector: 'merchan-distribution-tabs',
  templateUrl: './distribution-tabs.component.html',
  styleUrls: ['./distribution-tabs.component.scss'],
})
export class DistributionTabsComponent implements OnInit, OnChanges {
  @Input()
  productId?: number;

  @Input()
  total: number = 0;

  currentIndex = 0;

  minDate: Date = new Date();

  deliveryWays: Array<Reprint> = [];

  @Input()
  distribution: any;

  @Input()
  isDownload?: boolean;

  deliveryWayOptions: any[] = ProductService.getDeliveryWays();
  deliveryWayOptionsDownload: any[] = ProductService.getDeliveryWaysToDownload();

  prefixClassifications: ComboBoxOption[] = [];
  listDeliveryWayByGroup: ProductDistribution[] = [];
  listDeliveryWayAutomatic: ProductDistribution[] = [];
  listDeliveryWayDirect: ProductDistribution[] = [];
  listDeliveryWayRestrict: ProductDistribution[] = [];

  distributionTotalItens: Array<{ type: string; total: number; id?: number }> = [];

  currentDeliveryWay: any = {};

  checkedItens: Array<string> = [];

  currentInfo: PrintBatch = {};

  deliveryWayByGroup: Array<any> = [];
  deliveryWayDirect: Array<any> = [];
  deliveryWayRestrict: Array<any> = [];
  deliveryWayAutomatic: Array<any> = [];

  @Output()
  changed = new EventEmitter<any>();

  limitInvalid?: boolean = false;
  limitInvalidMessage?: string;

  isValid?: boolean = false;

  constructor(
    private productService: ProductService,
    private reprintService: ReprintService,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    // console.log('init distribution tabs - productId:', this.productId);
    // console.log('init distribution tabs - typeof productId:', typeof this.productId);
    // if (!this.productId) {
    //   console.warn('ProductId is falsy:', this.productId);
    //   return;
    // }
    // this.reprintService.getAll(this.productId).subscribe({
    //   next: data => {
    //     console.log('current_data', data);
    //     this.deliveryWays = data;
    //     this.initSettings();
    //   },
    //   error: err => {
    //     console.error('Erro ao buscar reprints', err);
    //   },
    // });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['productId']) {
      console.log(
        'productId changed from',
        changes['productId'].previousValue,
        'to',
        changes['productId'].currentValue
      );
      const newProductId = changes['productId'].currentValue;
      if (newProductId !== undefined && newProductId !== null) {
        this.reprintService.getAll(newProductId).subscribe({
          next: data => {
            console.log('current_data', data);
            this.deliveryWays = data;
            this.initSettings();
          },
          error: err => {
            console.error('Erro ao buscar reprints', err);
          },
        });
      }
    }
  }

  get itensDistrutionOptions() {
    return this.isDownload ? this.deliveryWayOptionsDownload : this.deliveryWayOptions;
  }

  resetPrintBatch() {
    this.checkedItens = [];
    this.listDeliveryWayAutomatic = [];
    this.listDeliveryWayByGroup = [];
    this.listDeliveryWayRestrict = [];
    this.listDeliveryWayDirect = [];
  }

  initSettings() {
    console.log('here', 'teste');
    this.resetPrintBatch();

    const {
      id,
      quantity,
      unitPrice,
      expectedOn,
      deliveryWayAutomatic,
      deliveryWayByGroup,
      deliveryWayRestrict,
      deliveryWayDirect,
    } = this.currentData;

    this.currentInfo = {
      id,
      quantity,
      unitPrice: unitPrice.toString(),
      expectedOn: new Date(expectedOn),
    };

    console.log('current_info', this.currentData);
    const ways = [
      {
        data: deliveryWayAutomatic,
        list: 'listDeliveryWayAutomatic',
        code: 'A',
      },
      { data: deliveryWayRestrict, list: 'listDeliveryWayRestrict', code: 'P' },
      { data: deliveryWayDirect, list: 'listDeliveryWayDirect', code: 'D' },
    ];

    ways.forEach(({ data, list, code }) => {
      if (data.length > 0) {
        (this as any)[list] = data;
        this.checkedItens.push(code);
      } else {
        (this as any)[list] = [];
      }
    });

    this.setDeliveryWayByGroup();

    this.setQuantities();
    this.onUpdateParent();
    this.cdr.detectChanges();
  }

  setDeliveryWayByGroup() {
    if (
      !!this.currentData &&
      !!this.currentData.deliveryWayByGroup &&
      this.currentData.deliveryWayByGroup.length > 0
    ) {
      this.checkedItens.push('C');
      if (this.isDownload) {
        this.listDeliveryWayByGroup = this.currentData.deliveryWayByGroup.map((item: any) => {
          let currentItem = Object.assign({}, item);

          currentItem.checked = currentItem.quantity === 1 ? true : false;

          return currentItem;
        });
      } else {
        this.listDeliveryWayByGroup = this.currentData.deliveryWayByGroup;
      }
    } else {
      this.productService.combobox('prefix_classifications').then(resp => {
        this.listDeliveryWayByGroup = resp.map((item: any) => ({
          detail: {
            id: item.value,
            label: item.label,
          },
          checked: false,
          quantity: 0,
        }));
        this.cdr.detectChanges();
      });
    }
  }

  setQuantities() {
    if (this.currentData) {
      const { quantityForGroup, quantityForDirect, quantityForRestrict, quantityForAutomatic, id } =
        this.currentData;

      const quantities = [
        {
          total: quantityForAutomatic,
          type: 'A',
        },
        { total: quantityForRestrict, type: 'P' },
        { total: quantityForDirect, type: 'D' },
        { total: quantityForGroup, type: 'C' },
      ];

      let itens: Array<{ type: string; total: number; id?: number }> = [];

      quantities.forEach((data, index: number) =>
        itens.push({ type: data.type, total: data.total, id: id })
      );

      this.distributionTotalItens = itens;
    }
  }

  get currentData() {
    return this.deliveryWays[this.currentIndex];
  }

  filterPrintBatch(index: number) {
    this.currentIndex = index;
    this.initSettings();
  }

  get info() {
    return this.deliveryWays[0];
  }

  newPrintBatch() {
    const newBatch: Reprint = {
      quantity: 0,
      unitPrice: 0,
      expectedOn: new Date(),
      deliveryWayAutomatic: [],
      deliveryWayByGroup: [],
      deliveryWayRestrict: [],
      deliveryWayDirect: [],
      registerDate: '',
      agencyPublicity: this.info.agencyPublicity,
      suplier: this.info.suplier,
      confirmed: false,
      presentation: '',
      quantityKits: 0,
      quantityForGroup: 0,
      quantityForAutomatic: 0,
      quantityForDirect: 0,
      quantityForRestrict: 0,
      updateAt: '',
      distributionForClassification: false,
      distributionForDependencies: false,
      confirmationDate: '',
      deliveryWays: [],
    };
    this.listDeliveryWayAutomatic = [];
    this.listDeliveryWayByGroup = [];
    this.listDeliveryWayDirect = [];
    this.listDeliveryWayRestrict = [];
    this.deliveryWays.push(newBatch);
    this.checkedItens = [];
    this.distributionTotalItens = [];
    this.currentInfo = {};

    this.currentIndex = this.deliveryWays.length - 1;
    this.initSettings();
  }

  removePrintBatch(event: any) {
    this.confirmationService.confirm({
      target: event.target!,
      header: 'Confirmação',
      message: `Deseja remover essa distribuição?`,
      icon: 'fa-solid fa-exclamation-triangle',
      acceptLabel: 'Sim',
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: 'Não',
      defaultFocus: 'reject',
      accept: (): void => {
        this.deliveryWays.splice(this.currentIndex, 1);

        this.listDeliveryWayAutomatic = [];
        this.listDeliveryWayByGroup = [];
        this.listDeliveryWayDirect = [];
        this.listDeliveryWayRestrict = [];
        this.checkedItens = [];

        this.currentIndex = this.currentIndex - 1;
        this.initSettings();

        if (this.currentInfo.id) {
          this.reprintService
            .remove(Number(this.productId), this.currentInfo.id)
            .pipe()
            .subscribe(item => {
              console.log(item);
            });
        }
      },
      reject: (): void => {
        // reject action
      },
    });
  }

  public deliveryWaysExists(value: string): boolean {
    const data = this.checkedItens.findIndex(e => e === value) > -1;
    return data;
  }

  public onChangeDeliveryWayItem(event: any, item: any): void {
    const i: number = this.checkedItens.findIndex(e => e === item.value);
    if (i > -1) {
      this.checkedItens.splice(i, 1);
    } else {
      this.checkedItens.push(item.value);
      if (item.value === 'C') {
        this.setDeliveryWayByGroup();
      }
    }

    this.onUpdateParent();
  }

  onChangeTotal(data: any) {
    const index = this.distributionTotalItens.findIndex(item => item.type === data.type);
    if (index > -1) {
      this.distributionTotalItens[index].total = data.total;
    } else {
      this.distributionTotalItens.push({ type: data.type, total: data.total });
    }

    this.validateTotal();
  }

  totalItensOnDistribution(type: string) {
    const index = this.distributionTotalItens.findIndex(item => item.type === type);
    return index > -1 ? this.distributionTotalItens[index].total : 0;
  }

  validateTotal(): void {
    const totalItens = Number(this.currentInfo.quantity);

    const sumDistribution = this.distributionTotalItens.reduce((acc, item) => acc + item.total, 0);

    if (sumDistribution > totalItens) {
      this.limitInvalidMessage =
        'A quantidade de itens distribuidos em cada modalidade, não pode ultrapassar a quantidade total produzida!';
      this.limitInvalid = true;
    } else if (sumDistribution < totalItens) {
      this.limitInvalidMessage =
        'A quantidade de itens distribuidos em cada modalidade, não pode ser menor a quantidade total produzida!';
      this.limitInvalid = true;
    } else {
      this.limitInvalid = false;
      this.limitInvalidMessage = '';
    }
  }

  onGroupChange(data: any) {
    this.listDeliveryWayByGroup = data;
    this.onUpdateParent();
  }

  onAutomaticChange(data: any) {
    this.listDeliveryWayAutomatic = data;
    this.onUpdateParent();
  }

  onDirectChange(data: any) {
    this.listDeliveryWayDirect = data;
    this.onUpdateParent();
  }

  onRestrictChange(data: any) {
    this.listDeliveryWayRestrict = data;
    this.onUpdateParent();
  }

  onUpdateParent() {
    let obj = {
      isValid: this.isValid,
      deliveryWays: this.checkedItens,
      printBatch: {
        ...this.currentInfo,
        ...{ distributionTotalItens: this.distributionTotalItens },
      },
      deliveryWayByGroup: this.listDeliveryWayByGroup,
      deliveryWayAutomatic: this.listDeliveryWayAutomatic,
      deliveryWayDirect: this.listDeliveryWayDirect,
      deliveryWayRestrict: this.listDeliveryWayRestrict,
    };

    this.validateData();

    console.log('sendParent', obj);

    this.changed.emit(obj);
  }

  get confirmedFake() {
    return false;
  }

  get isConfirmedPrintBatch() {
    //return false;
    return !!this.currentData && this.currentData.confirmed;
  }

  validateData() {}

  private showWarningValidate(msg: string) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Aviso',
      detail: msg,
    });
  }
}
